import { ref } from "vue";
import { useWisepops } from "./wisepops";

export const useDownload = () => {
  const downloading = ref(false);

  const startDownload = async (fn: (...args: any[]) => Promise<any>) => {
    if (downloading.value) {
      return;
    }

    useWisepops().trigger("image-resizer-download-click");

    try {
      downloading.value = true;
      await fn();
    } finally {
      downloading.value = false;
    }
  };

  return { downloading, startDownload };
};
